"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[793],{

/***/ 66176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _insightfulscience_atomic_react_Picture__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20856);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67478);
/* harmony import */ var _Image_Caption__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7267);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10334);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67924);









const FImage = (param)=>{
    let { caption , imageCaptionClassName , isImageFrame , imageClassName , shadow , src , srcList =[] , alt , isBaseUrl  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Image_Caption__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        caption: caption,
        className: imageCaptionClassName,
        children: [
            srcList.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Picture__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: src,
                srcList: srcList,
                className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_7__/* .classes */ .S)(isImageFrame && "feature__image--frame", imageClassName),
                isBaseUrl: isBaseUrl
            }) : null,
            src && !srcList.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_7__/* .classes */ .S)(isImageFrame && "feature__image--frame", imageClassName),
                shadow: shadow,
                src: src,
                alt: alt,
                isBaseUrl: isBaseUrl
            }) : null
        ]
    });
};
FImage.propTypes = {
    shadow: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    src: prop_types__WEBPACK_IMPORTED_MODULE_8__.string.isRequired,
    srcList: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.arrayOf)((0,prop_types__WEBPACK_IMPORTED_MODULE_8__.shape)(_insightfulscience_atomic_react_Picture__WEBPACK_IMPORTED_MODULE_3__/* .sourceItemPropTypes */ .Y)),
    alt: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    caption: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    isImageFrame: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    imageCaptionClassName: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    imageClassName: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    isBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool
};
const FeatureImage = (param)=>/*#__PURE__*/ {
    let { shadow =false , src , srcList =[] , alt ="" , caption ="" , sm =12 , md =6 , className ="" , isImageFrame =false , imageCaptionClassName ="" , imageClassName ="" , isBaseUrl , href ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        sm: sm,
        md: md,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_7__/* .classes */ .S)("feature__image", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "feature__image--indent",
            children: href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                href: href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FImage, {
                    caption: caption,
                    imageCaptionClassName: imageCaptionClassName,
                    isImageFrame: isImageFrame,
                    imageClassName: imageClassName,
                    shadow: shadow,
                    src: src,
                    srcList: srcList,
                    alt: alt,
                    isBaseUrl: isBaseUrl
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FImage, {
                caption: caption,
                imageCaptionClassName: imageCaptionClassName,
                isImageFrame: isImageFrame,
                imageClassName: imageClassName,
                shadow: shadow,
                src: src,
                srcList: srcList,
                alt: alt,
                isBaseUrl: isBaseUrl
            })
        })
    });
};
FeatureImage.propTypes = {
    shadow: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    src: prop_types__WEBPACK_IMPORTED_MODULE_8__.string.isRequired,
    srcList: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.arrayOf)((0,prop_types__WEBPACK_IMPORTED_MODULE_8__.shape)(_insightfulscience_atomic_react_Picture__WEBPACK_IMPORTED_MODULE_3__/* .sourceItemPropTypes */ .Y)),
    alt: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    caption: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    sm: _Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col.propTypes.sm */ .JX.propTypes.sm,
    md: _Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col.propTypes.md */ .JX.propTypes.md,
    isImageFrame: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    imageCaptionClassName: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    imageClassName: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    isBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    href: prop_types__WEBPACK_IMPORTED_MODULE_8__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureImage);


/***/ }),

/***/ 1041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2349);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6949);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67478);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7820);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18981);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23720);











const Label = (param)=>/*#__PURE__*/ {
    let { children , type ="default" , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .tF
    } , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta-label-".concat(type), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingClassName */ .RB)(spacing)),
        ...props,
        children: children
    });
};
Label.propTypes = {
    type: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf)([
        "default",
        "without-line"
    ]),
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired
};
const Title = (param)=>/*#__PURE__*/ {
    let { utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_7__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_8__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .tF
    } , children , className ="" , underline , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h3",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta-title", underline && "feature__meta-title--border-".concat(underline), ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_7__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_8__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* .deepMergeProps */ .p)({
            fontSize: "l"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Title.propTypes = {
    underline: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf)([
        "top-left",
        "top-right",
        "top-right--md"
    ]),
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const Description = (param)=>/*#__PURE__*/ {
    let { children , className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta-description", className),
        ...props,
        children: children
    });
};
Description.propTypes = {
    ..._Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"].propTypes */ .Z.propTypes
};
const Action = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: children
    });
};
Action.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired
};
const FeatureMeta = (param)=>{
    let { numberItem , children , sm =12 , md =6 , className ="" , indent =true , numberProps ={} , ...props } = param;
    const { sx ={} , utility ={} , spacing ={}  } = numberProps;
    const blockClassName = (numberProps === null || numberProps === void 0 ? void 0 : numberProps.className) || null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        sm: sm,
        md: md,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)(indent && "feature__meta--indent"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X2, {
                children: [
                    numberItem ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                        shrink: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta-number", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_7__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(utility)), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_8__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(sx)), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(spacing)), blockClassName),
                            children: numberItem
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                        auto: true,
                        children: children
                    })
                ]
            })
        })
    });
};
FeatureMeta.propTypes = {
    numberItem: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired,
    sm: _Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col.propTypes.sm */ .JX.propTypes.sm,
    md: _Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col.propTypes.md */ .JX.propTypes.md,
    indent: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    numberProps: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.shape)({
        sx: _props_sx__WEBPACK_IMPORTED_MODULE_8__/* .sxPropTypes */ .I1,
        spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingPropTypes */ .Xj,
        utility: _props_utility__WEBPACK_IMPORTED_MODULE_7__/* .utilityPropTypes */ .pQ,
        className: prop_types__WEBPACK_IMPORTED_MODULE_9__.string
    })
};
FeatureMeta.Label = Label;
FeatureMeta.Title = Title;
FeatureMeta.Description = Description;
FeatureMeta.Action = Action;
/* harmony default export */ __webpack_exports__["Z"] = (FeatureMeta);


/***/ }),

/***/ 55185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Feature_Feature; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Feature.js





const Feature = (param)=>{
    let { top =false , middle =true , children , className ="" , ...props } = param;
    const alignProps = top === true ? {
        start: true,
        middle: false
    } : {
        start: false,
        middle
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        px: true,
        className: (0,classes/* classes */.S)("feature", className),
        ...alignProps,
        ...props,
        children: children
    });
};
Feature.propTypes = {
    top: prop_types.bool,
    middle: prop_types.bool,
    children: prop_types.node.isRequired,
    className: prop_types.string
};
/* harmony default export */ var Feature_Feature = (Feature);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/index.js



/***/ }),

/***/ 14593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36432);




const HeroAction = (param)=>/*#__PURE__*/ {
    let { center =true , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroRow */ .P, {
        center: center,
        className: "section-hero__action",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroCol */ .Z, {
            children: children
        })
    });
};
HeroAction.propTypes = {
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroAction);


/***/ }),

/***/ 85765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const HeroButtonLink = (param)=>{
    let { className ="" , size ="s" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Link */ .Z.Link, {
        size: size,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__button", className),
        ...props
    });
};
HeroButtonLink.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    size: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    ..._Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroButtonLink);


/***/ }),

/***/ 50410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6949);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23720);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroDescription = (param)=>{
    let { align , color ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__description", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroDescription.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .textAlignPropTypes */ .g4,
    color: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .colorPropTypes */ .AK,
    ..._Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroDescription);


/***/ }),

/***/ 36432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ HeroRow; },
/* harmony export */   "Z": function() { return /* binding */ HeroCol; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const HeroCol = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: "shrink",
        ...props
    });
};
HeroCol.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes
};
const HeroRow = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        my: true,
        center: true,
        ...props
    });
};
HeroRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes
};


/***/ }),

/***/ 30389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84154);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23720);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67924);






const HeroBackground = (param)=>{
    let { hAlign ="right" , vAlign ="bottom" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)("section-hero__background", "section-hero__background--".concat(hAlign), "section-hero__background--".concat(vAlign)),
        children: children
    });
};
HeroBackground.propTypes = {
    hAlign: _props_sx__WEBPACK_IMPORTED_MODULE_3__/* .textAlignPropTypes */ .g4,
    vAlign: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOf)([
        "top",
        "middle",
        "bottom"
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const HeroBackgroundImages = (param)=>{
    let { isBaseUrl =true , images =[] , imagePositions =[] , color ="transparent" , children  } = param;
    const ctxBaseUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_2__/* ["default"].context */ .Z.context);
    const baseUrl = isBaseUrl ? ctxBaseUrl : "";
    const styles = !images.length ? {} : {
        backgroundImage: images.map((src)=>"url(".concat(baseUrl).concat(src, ")")).join(","),
        backgroundPosition: imagePositions.join(",")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)("section-hero__background-images", "section-hero-color-".concat(color)),
        style: {
            ...styles
        },
        children: children
    });
};
HeroBackgroundImages.propTypes = {
    isBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool,
    images: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_5__.string),
    imagePositions: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_5__.string),
    color: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOf)([
        "1",
        "1--light",
        "2",
        "3",
        "4",
        "5",
        "6",
        "white",
        "black--02",
        "dotmatics-8",
        "transparent",
        "gradient"
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
HeroBackground.Images = HeroBackgroundImages;
/* harmony default export */ __webpack_exports__["Z"] = (HeroBackground);


/***/ }),

/***/ 72989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42866);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6949);
/* harmony import */ var _r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12985);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18981);














const Title = (param)=>/*#__PURE__*/ {
    let { className ="" , color , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h2",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mb: 0,
            mt: 0
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
Title.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const TitleV2 = (param)=>/*#__PURE__*/ {
    let { className ="" , color , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h2",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__title-v2", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mb: 0,
            mt: 0
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
TitleV2.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const DescriptionV2 = (param)=>/*#__PURE__*/ {
    let { className ="" , color , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    }  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__description-v2", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            fontSize: "l",
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mt: 4
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        children: children
    });
};
DescriptionV2.propTypes = {
    color: _props_sx__WEBPACK_IMPORTED_MODULE_9__/* .colorPropTypes */ .AK,
    ..._Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"].propTypes */ .Z.propTypes
};
const Body = (param)=>/*#__PURE__*/ {
    let { children =null  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
Body.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_13__.node
};
const Action = (param)=>/*#__PURE__*/ {
    let { ActionComponent =_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        utility: {
            justify: "center"
        },
        spacing: {
            mt: 8
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
            sx: {
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActionComponent, {
                ...props,
                children: children
            })
        })
    });
};
Action.propTypes = {
    ActionComponent: prop_types__WEBPACK_IMPORTED_MODULE_13__.elementType,
    children: prop_types__WEBPACK_IMPORTED_MODULE_13__.node.isRequired
};
const LandingSimpleSection = (param)=>{
    let { className ="" , isBorderNone =false , bgColor , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , children , containerProps , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section", !isBorderNone && "landing-simple-section--border-bottom", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            bgColor
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(utility))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            ...containerProps,
            children: children
        })
    });
};
LandingSimpleSection.propTypes = {
    bgColor: _props_sx__WEBPACK_IMPORTED_MODULE_9__/* .colorPropTypes */ .AK,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_13__.bool,
    containerProps: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.shape)({
        sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        md: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        center: prop_types__WEBPACK_IMPORTED_MODULE_13__.bool
    }),
    ..._Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const SectionLabel = (param)=>{
    let { utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__label", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)(spacing), className),
        children: children
    });
};
SectionLabel.propTypes = {
    ..._Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"].propTypes */ .Z.propTypes
};
LandingSimpleSection.Label = SectionLabel;
LandingSimpleSection.Title = Title;
LandingSimpleSection.TitleV2 = TitleV2;
LandingSimpleSection.DescriptionV2 = DescriptionV2;
LandingSimpleSection.Body = Body;
LandingSimpleSection.Action = Action;
/* harmony default export */ __webpack_exports__["Z"] = (LandingSimpleSection);


/***/ }),

/***/ 37045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _SimpleSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72989);




const LandingSimpleSectionStripped = (param)=>{
    let { isDark =false , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SimpleSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        utility: {
            bgColor: isDark ? "black--02" : null
        },
        isBorderNone: true,
        ...props
    });
};
LandingSimpleSectionStripped.propTypes = {
    isDark: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    ..._SimpleSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingSimpleSectionStripped);


/***/ }),

/***/ 13398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Panel_Panel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/Panel.js





const Panel = (param)=>{
    let { className ="" , shadow , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: (0,classes/* classes */.S)("panel", shadow && "panel--shadow", className),
        ...props
    });
};
Panel.propTypes = {
    shadow: prop_types.bool,
    ...Block/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Panel_Panel = (Panel);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js



/***/ }),

/***/ 51204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oe": function() { return /* binding */ SectionStart30DayTrial; },
/* harmony export */   "gj": function() { return /* binding */ SectionStart30DayTrialText; },
/* harmony export */   "kc": function() { return /* binding */ SectionStart30DayTrialButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93512);
/* harmony import */ var _insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67478);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _insightfulscience_atomic_react_PostElement__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77626);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18774);







const SectionStart30DayTrial = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
                    spacing: {
                        pt: 5
                    },
                    sx: {
                        textAlign: "center"
                    },
                    children: children
                })
            })
        })
    });
};
SectionStart30DayTrial.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const SectionStart30DayTrialButton = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Link */ .Z.Link, {
        ...props
    });
};
SectionStart30DayTrialButton.propTypes = {
    ..._Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const SectionStart30DayTrialText = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_PostElement__WEBPACK_IMPORTED_MODULE_4__/* .PostElementParagraph */ .DK, {
        className: "text-color-white",
        ...props
    });
};
SectionStart30DayTrialText.propTypes = {
    ..._insightfulscience_atomic_react_PostElement__WEBPACK_IMPORTED_MODULE_4__/* .PostElementParagraph.propTypes */ .DK.propTypes
};


/***/ }),

/***/ 87385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleTemplate_SimpleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sizing.js
var sizing = __webpack_require__(88270);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js + 1 modules
var Panel = __webpack_require__(13398);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/SimpleTemplate.js











const SimpleTemplate = (param)=>{
    let { cellWidth =8 , mdCellWidth =10 , paddingTop ="pt-9 pt-9--md" , paddingBottom ="pb-18 pb-18--md" , panel =true , panelPaddingY =16 , panelUtility ={
        ...props_utility/* utilityProps */.Gm
    } , children , bgColor =color/* bgColorBlack2 */.vk , className ="" , shadow =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , panelSizing ={
        ...sizing/* sizingProps */.H6
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(paddingTop, paddingBottom, !(utility && utility.bgColor) && bgColor, ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: mdCellWidth,
                    lg: cellWidth,
                    children: panel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel/* default */.Z, {
                        shadow: shadow,
                        utility: panelUtility,
                        sizing: panelSizing,
                        spacing: {
                            py: panelPaddingY
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                            mx: true,
                            px: true,
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 10,
                                children: children
                            })
                        })
                    }) : children
                })
            })
        })
    });
};
SimpleTemplate.propTypes = {
    shadow: prop_types.bool,
    cellWidth: prop_types.number,
    mdCellWidth: prop_types.number,
    paddingTop: prop_types.string,
    paddingBottom: prop_types.string,
    panel: prop_types.bool,
    panelPaddingY: prop_types.number,
    panelUtility: props_utility/* utilityPropTypes */.pQ,
    children: prop_types.node.isRequired,
    bgColor: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    panelSizing: sizing/* sizingPropTypes */.bm,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var SimpleTemplate_SimpleTemplate = (SimpleTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 93816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72989);



/***/ }),

/***/ 75833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export pipeA */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

const pipe = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>fn(val), value);
};
const pipeA = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>(0,___WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(val) ? val.then(fn) : fn(val), value);
};
pipe.async = pipeA;
/* harmony default export */ __webpack_exports__["Z"] = (pipe);


/***/ }),

/***/ 21607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Checks if value is an integer number
 *
 * @type {(value: any) => boolean}
 */ const isInt = (value)=>value != null && value !== "" && Number.isInteger(+value);
/* harmony default export */ __webpack_exports__["Z"] = (isInt);


/***/ }),

/***/ 66651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

class ApplicationError extends Error {
    toSerializable() {
        const { name , message , code , stack , originalError , tags  } = this;
        return {
            name,
            message,
            code,
            stack: typeof stack === "string" ? stack.split("\n") : stack,
            originalError: originalError ? {
                name: originalError.name,
                code: originalError.code,
                message: originalError.message
            } : null,
            tags
        };
    }
    toJSON() {
        return this.toSerializable();
    }
    constructor(originalError, code = 500, message = ApplicationError.defaultMessage[code], tags = null){
        super(message);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "name", "ApplicationError");
        this.code = code;
        this.originalError = originalError;
        this.stack = (originalError === null || originalError === void 0 ? void 0 : originalError.stack) || new Error().stack;
        this.tags = tags;
    }
}
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "defaultMessage", {
    400: "Bad Request",
    401: "Not Authorized",
    403: "Not Permitted",
    404: "Not Found",
    500: "Internal Error",
    503: "Service Unavailable"
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "of", (error)=>error instanceof ApplicationError ? error : new ApplicationError(error, error.code || 500, error.message));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "BadRequest", ()=>new ApplicationError(null, 400));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotAuthorized", ()=>new ApplicationError(null, 401));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotFound", ()=>new ApplicationError(null, 404));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "ServiceUnavailable", ()=>new ApplicationError(null, 503));
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationError);


/***/ }),

/***/ 73446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




const PageTitle = (param)=>{
    let { title  } = param;
    return title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "title")
        ]
    }) : null;
};
PageTitle.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ })

}]);